
import NavHeader from "@/nav/NavHeader.vue";
import BulkStoreTaskTable from "@/components/bulk/BulkStoreTaskTable.vue";

import { defineComponent } from "vue";
import { getBulkStoreTaskState } from "@/pinia/tasks/BulkStoreTaskState";
import * as Lang from "@/i18n/lang";
import * as Modals from "@/utils/Modals";

export default defineComponent({
  async setup() {
    let state = getBulkStoreTaskState();

    await state.setup();

    return {
      state: state,
    };
  },

  async beforeRouteLeave(to, from, next) {
    if (to.name == "storeTaskConf") {
      next();
      return;
    }
    let changes = getBulkStoreTaskState().hasChanges();

    if (!changes) {
      next();
    } else {
      const confirmLeave = await Modals.openYesNo(
        Lang.getI18N("unsaved-changes"),
        "Secureat",
        Lang.getI18N("yes"),
        Lang.getI18N("no")
      );

      if (confirmLeave) {
        next();
      } else {
        next(false);
      }
    }
  },

  data() {
    return {
      Lang: Lang,
    };
  },
  async mounted() {},
  methods: {},
  components: { BulkStoreTaskTable },
});
